export enum DynamicViewConfigSettings {
    DV_USM_MODAL = 'DV_USM_MODAL',
    DV_ADMIN_SHARING_USAGE = 'DV_ADMIN_SHARING_USAGE',
    DV_LICENSE_DECOUPLE = 'DV_LICENSE_DECOUPLE',
    DV_REPORTS_DECOUPLE = 'DV_REPORTS_DECOUPLE',
}
